import type { ApiKey, CreateApiKeyResult } from "@repo/shared/types";
import { del, get, patch, post } from "@/lib/api/_client";

export function getApiKeys() {
  return get<ApiKey[]>("/internal/api-keys");
}

export function createApiKey(data: { name: string; expiresAt?: string }) {
  return post<CreateApiKeyResult>("/internal/api-keys", data);
}

export function toggleApiKey(id: string) {
  return patch<void>(`/internal/api-keys/${id}/toggle`);
}

export function deleteApiKey(id: string) {
  return del<void>(`/internal/api-keys/${id}`);
}
